import ClassNameBuilder from '../../../tools/ClassNameBuilder'
import { BoltIcon, FilterIcon } from '../inline-svg'

declare type CustomIconName = 'bolt' | 'filter'

interface CustomIconProps {
    name: CustomIconName
    size?: number
    // Because PrimeReact uses classes and css to create icon layouts,
    //  it can be necessary to manually declare custom element icons as using the same margin.
    margin?: boolean
    spin?: boolean
    className?: string
}

const CustomIconMap = ({ name }: { name: CustomIconName }) => {
    switch (name) {
        case 'bolt':
            return <BoltIcon />
        case 'filter':
            return <FilterIcon />
    }
}

export default function CustomIcon({ name, size, margin, spin, className }: CustomIconProps) {
    const classNames = new ClassNameBuilder()
        .add(ci(name))
        .add(className)
        .addIf('ci-margin', margin)
        .addIf('pi-spin', spin)
    return (
        <i className={classNames.toString()} style={{ width: size, aspectRatio: 1 }}>
            <CustomIconMap name={name} />
        </i>
    )
}

export const ci = (name: CustomIconName) => `ci ci-${name}`
